import { takeEvery, put, select } from 'redux-saga/effects';
import { takePostAcqValuation, setPostAcqTransientValuation, setPostAcqSelectedValuation, setPostAcqViewUnderwriteModalIsOpen, appNotify } from 'store/actions';
import { userSelector, postAcqUWStateSelector, postAcqTransientValuationSelector } from 'store/selectors';
import { removeInvalidProformaInputs } from 'services/postAcqTaskUWDataService';
import { sendClientLog } from 'services/logService';

export function* postAcqTakeValuationSaga() {
  yield takeEvery(takePostAcqValuation, function* ({ payload: valuationToTake }) {
    try {
      const { selectedProformaInputsContainer, selectedOpportunityComps, underwriteModalState } = yield select(postAcqUWStateSelector);
      const user = yield select(userSelector);

      const transientValuation = yield select(postAcqTransientValuationSelector);
      const newTransientValuation = { // create new transient valuation object but with other person's valuation
        ...valuationToTake,
        createdOn: transientValuation.createdOn,
        id: transientValuation.id,
        isLatest: transientValuation.isLatest,
        user: transientValuation.user,
        postAcquisitionLoadInstanceId: transientValuation.postAcquisitionLoadInstanceId,
        takenValuationId: valuationToTake.id
      }

      const mappedValuationsComps = [];
      const unmappedValuationsComps = [];
      const valuationToTakeSelectedCompIds = underwriteModalState.selectedValuation.valuationsComps.map(el => el.compId);
      const valuationToTakeSelectedComps = underwriteModalState.selectedOpportunityComps.filter(comp => valuationToTakeSelectedCompIds.includes(comp.id));
      valuationToTakeSelectedComps.forEach(selectedComp => {
        const foundComp = selectedOpportunityComps.find(origComps => origComps.compAsgPropertyId === selectedComp.compAsgPropertyId && origComps.compType === selectedComp.compType);
        if (foundComp) {
          mappedValuationsComps.push({ compId: foundComp.id });
        } else {
          unmappedValuationsComps.push(selectedComp.streetAddress);
        }
      });
      newTransientValuation.valuationsComps = mappedValuationsComps;

      function* callback(invalidFields) {
        if (unmappedValuationsComps?.length) {
          invalidFields += `\n\nIncompatible comps:`;
          unmappedValuationsComps.forEach(comp => {
            invalidFields += `\n${comp}`;
          });
        }
        
        yield put(appNotify(
          `Took ${valuationToTake.user?.fullName}'s Underwrite` + invalidFields,
          'success',
          {
            persist: invalidFields.length > 0,
            ContentProps: {
              classes: {
                root: 'multilineSnackbarContentRoot',
                message: 'multilineSnackbarContentMessage',
                action: 'multilineSnackbarContentAction'
              }
            }
          }
        ));
        yield put(setPostAcqViewUnderwriteModalIsOpen(false));
        sendClientLog('Info', `Post-Acq UW - User took valuation from history modal. Source valuationId ${valuationToTake.id}. Destination loadInstanceId ${transientValuation.postAcquisitionLoadInstanceId}, valuationId ${transientValuation.id}`);    
      }

      yield put(setPostAcqSelectedValuation(selectedProformaInputsContainer.valuations.find(x => x.user.id === user.id)));      // set back to user's valuation
      // yield put(setPostAcqTransientValuation(newTransientValuation));
      const { updatedTransientValuation, invalidFields } = yield removeInvalidProformaInputs(newTransientValuation);
      yield put(setPostAcqTransientValuation(updatedTransientValuation));
      yield callback(invalidFields);
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
  });
}
